module.exports = __webpack_public_path__ + "static/media/aboutPagesContent.43f79674.yaml";